import DashboardOverview from '../components/DashboardOverview'

const DashboardMainContent = () => {
  return (
<>
    <div className=''>
      <DashboardOverview />
    </div>

</>  )
}

export default DashboardMainContent